import React from 'react';
import './BirthdayCard.css';

const BirthdayCard = ({ person }) => {
  const { nombre, dia, nombreMes, ano, edad } = person;

  return (
    <div className="birthday-card card">
      <div className="body">
        <div className="b-name title">{nombre}</div>
        <div className="b-date meta">{dia} de {nombreMes} de {ano}</div>
        <div className="b-age"><span>{edad}</span> años</div>
      </div>
    </div>
  );
};

export default BirthdayCard;
